/**
 * Display toggle for advertised **subscription** pricing (plans and recurring
 * add-ons).
 *
 * Ships DISABLED: with this `false`, no plan or add-on price amount, billing
 * interval switch, savings claim, or cart total is rendered anywhere, and
 * purchase intent is captured as a sales lead instead of opening Stripe
 * checkout — so a customer is never charged against a price they were not
 * quoted. Flip to `true` to restore the previous behaviour in one edit; the
 * price data, the currency formatting, and the checkout paths all remain in
 * place behind this flag rather than being deleted.
 *
 * Scope is subscriptions only. **Coin purchases are unaffected** — token
 * pack prices are always shown and always self-serve, so customers can buy more
 * capacity as they grow. Invoice history and the Stripe Customer Portal are
 * likewise unaffected: those are records of a completed transaction, not an
 * offer.
 *
 * See docs/business/subscription-pricing-display.md.
 */
export const ADVERTISE_SUBSCRIPTION_PRICING = true;
